import { render, staticRenderFns } from "./NewImport.vue?vue&type=template&id=1ad4fd4b&"
import script from "./NewImport.vue?vue&type=script&lang=js&"
export * from "./NewImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports